import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/salesCopy';
import { checkoutUrl } from '../data/offer';
import { handleCheckoutClick } from './CtaButton';
export function BonusStack() {
  return <section className="w-full border-b border-line bg-surface" data-id="element-10" data-mp="2lsxc71dulbo">
      <div className="mx-auto max-w-6xl px-4 py-12 sm:px-5 sm:py-16 lg:py-20" data-id="element-11" data-mp="6lte3ybyf8lw">
        <div className="max-w-2xl" data-id="element-12" data-mp="6jqkl4blexcf">
          <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-rust sm:text-xs" data-id="element-13" data-mp="361zqvkq3326q">
            Included today at no extra cost
          </p>
          <h2 className="mt-3 font-display text-2xl font-semibold leading-tight tracking-tight text-ink sm:mt-4 sm:text-4xl" data-id="element-14" data-mp="3axx3bfy87oe8">
            The irresistible bonuses
          </h2>
          <p className="mt-3 text-[15px] leading-relaxed text-ink-soft sm:mt-4 sm:text-lg" data-id="element-15" data-mp="3jtwfhesjmtyd">
            Five free guides that solve what method books never touch — practice motivation, studio
            admin, parent communication, and your pricing.
          </p>
        </div>

        <ul className="mt-8 grid grid-cols-1 gap-4 sm:mt-12 sm:grid-cols-2 sm:gap-6 lg:grid-cols-3" data-id="element-16" data-mp="3s9ialxpk7qan">
          {bonuses.map(bonus => <li key={bonus.number} className="flex h-full flex-row overflow-hidden rounded-2xl border border-line bg-paper sm:flex-col" data-id="element-17" data-mp="3ne2zhdixs8hx">
              <div className="w-28 shrink-0 bg-ink sm:w-full" data-id="element-18" data-mp="3dlnhig7n3jx1">
                <img src={bonus.cover} alt={`Cover of ${bonus.title}`} className="h-full w-full object-cover sm:aspect-square" data-id="element-19" data-mp="38nvo1hrcjpqq" />
              </div>
              <div className="flex flex-1 flex-col p-4 sm:p-6" data-id="element-20" data-mp="2zmo301duclel">
                <div className="flex flex-wrap items-center gap-x-2 gap-y-1" data-id="element-21" data-mp="2unku25uqpv1c">
                  <span className="text-[10px] font-semibold uppercase tracking-[0.14em] text-ink-muted sm:text-xs" data-id="element-22" data-mp="xure7q2nxf1v">
                    Bonus {bonus.number}
                  </span>
                  <span className="rounded-full bg-rust-soft px-2 py-0.5 text-[10px] font-semibold text-rust-dark sm:px-2.5 sm:text-xs" data-id="element-23" data-mp="stvdtmhisb17">
                    <span className="line-through" data-id="element-24" data-mp="2s34y651itncg">{bonus.value}</span> · Free
                  </span>
                </div>
                <h3 className="mt-1.5 font-display text-base font-semibold leading-tight text-ink sm:mt-2 sm:text-xl" data-id="element-25" data-mp="2df1tcyz7shp8">
                  {bonus.title}
                </h3>
                <p className="mt-2 text-[13px] leading-relaxed text-ink-soft sm:mt-3 sm:text-[15px]" data-id="element-26" data-mp="361v141b0uh8q">
                  {bonus.body}
                </p>
              </div>
            </li>)}

          <li className="flex h-full flex-col justify-center rounded-2xl bg-ink p-6 text-paper sm:p-8" data-id="element-27" data-mp="2w4qczvxm8bpa">
            <GiftIcon className="h-7 w-7 text-rust-soft sm:h-8 sm:w-8" aria-hidden="true" data-id="element-28" data-mp="312ibj8srmw2g" />
            <p className="mt-4 font-display text-xl font-semibold leading-tight sm:mt-5 sm:text-2xl" data-id="element-29" data-mp="1kojte6tsewg1">
              All 5 bonuses, yours free
            </p>
            <p className="mt-3 text-[15px] leading-relaxed text-paper/70" data-id="element-30" data-mp="1pm1tr8tqo3cf">
              Every bonus is included with the bundle today — all in PDF, sent to your email. No
              upsells, no extra fees.
            </p>
            <a href={checkoutUrl} rel="noopener" onClick={() => handleCheckoutClick('bonus_section')} className="mt-6 inline-flex w-full items-center justify-center rounded-full bg-rust px-6 py-3.5 text-xs font-semibold uppercase tracking-[0.06em] text-white transition-[transform,background-color] duration-150 ease-expo hover:-translate-y-0.5 hover:bg-rust-dark active:translate-y-0 sm:w-fit" data-id="element-31" data-mp="gqxyvaw233th">
              Claim the bundle for $19
            </a>
          </li>
        </ul>
      </div>
    </section>;
}